import { render, staticRenderFns } from "./btn.vue?vue&type=template&id=5d0c1359&scoped=true&"
import script from "./btn.vue?vue&type=script&lang=js&"
export * from "./btn.vue?vue&type=script&lang=js&"
import style0 from "./btn.vue?vue&type=style&index=0&id=5d0c1359&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0c1359",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0c1359')) {
      api.createRecord('5d0c1359', component.options)
    } else {
      api.reload('5d0c1359', component.options)
    }
    module.hot.accept("./btn.vue?vue&type=template&id=5d0c1359&scoped=true&", function () {
      api.rerender('5d0c1359', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/activity/fudeGift/btn.vue"
export default component.exports